var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVoicings = function SvgVoicings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#voicings_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.692,
    y: 8.461,
    width: 4.923,
    height: 18.769,
    rx: 2.462,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.23,
    y: 3.231,
    width: 4.923,
    height: 29.538,
    rx: 2.462,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.769,
    y: 10.923,
    width: 4.923,
    height: 13.846,
    rx: 2.462,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.608 3.45c.761.19 1.514-.349 1.681-1.205.168-.857-.314-1.707-1.076-1.898-.761-.192-1.515.348-1.682 1.204-.167.857.315 1.707 1.077 1.898ZM20.806 34.78c.483.122.96-.22 1.066-.764.106-.543-.2-1.081-.682-1.203-.483-.121-.96.22-1.067.764-.106.543.2 1.082.683 1.203Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.847 23.217c4.008 1.739 4.707 1.556 7.509-1.793-1.714 4.055-1.533 4.762 1.78 7.6-4.009-1.738-4.708-1.556-7.51 1.794 1.721-4.026 1.551-4.75-1.78-7.6ZM1.285 14.337c2.68-1.458 2.885-1.923 2.298-4.927 1.44 2.709 1.9 2.917 4.869 2.32-2.68 1.46-2.885 1.924-2.298 4.928-1.42-2.7-1.885-2.922-4.869-2.321Z",
    fill: "#fff",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "voicings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h60v35H0z"
  })))));
};
export default SvgVoicings;